import { render, staticRenderFns } from "./elArchivesDeviceTree.vue?vue&type=template&id=681cb219&scoped=true&"
import script from "./elArchivesDeviceTree.vue?vue&type=script&lang=js&"
export * from "./elArchivesDeviceTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681cb219",
  null
  
)

export default component.exports